import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-train-spinner',
  templateUrl: './train-spinner.component.html',
  styleUrls: ['./train-spinner.component.scss']
})
export class TrainSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
